import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { injectIntl } from 'react-intl';

// prettier-ignore
const Translate = props => {
    const {
        intl,
        message,
        values,
        words = null,
        children = null,
        failSilently = false // 'true' means message may be unpredictable ( and cannot be used as intl key ) e.g.: from BE
    } = props;

    const toTranslatedString = (str, obj) => {
        return str
            ? intl.formatMessage(
                {
                    defaultMessage: str,
                    id: str.toLowerCase()
                },
                obj || null
            )
            : '';
    };

    const getEnrichedValues = () => {
        if(words){
            const enriched = values ? { ...values } : {};
            for (const [key, word] of Object.entries(words)) {
                enriched[key] = toTranslatedString(word);
            }
            return enriched;
        }
        return values;
    };

    const [appliedValues, setAppliedValues] = useState(getEnrichedValues());

    const getTranslatedString = () => {
        return message ? (
            (
                failSilently &&
                !intl.messages[message.toLowerCase()]
            )
                ? message
                : toTranslatedString(message, appliedValues)
        ) : '';
    }

    const [translated, setTranslated] = useState(getTranslatedString());

    useEffect(() => {
        setAppliedValues(getEnrichedValues());
    }, [values]);

    useEffect(() => {
        setTranslated(getTranslatedString())
    }, [message,appliedValues]);

    return children ? children(translated,appliedValues) : translated;
};

Translate.propTypes = {
    failSilently: PropTypes.bool,
    message: PropTypes.string.isRequired,
    values: PropTypes.object,
    words: PropTypes.object
};

export default injectIntl(Translate);

/*
 note:
     formatjs.io
     formatjs.io/docs/react-intl/
     formatjs.io/docs/react-intl/components/#formattedmessage

 Snippet:
        <Translate message={message} values={values} />

        <Translate message="" />
        Translate({ message:"" })

        <Translate message={message} values={values}>
          {
            translated => <i>{translated}</i>
          }
        </Translate>

 Examples:
          #1
                'Hello, {name}!'
                {name: 'Eric'}

          #2
                'Hello, <tag>Eric</tag>'
                {
                    tag: chunks => {
                        return <b>{chunks}</b>;
                    }
                }

          #3
                'Hello, <b>Eric</b> {icon}'
                {
                    b: chunks => {
                        return <h3>{chunks}</h3>;
                    },
                    icon: <svg />
                }

           #4
                'plural sample i:{i} become {i, plural, =0 {no items} one {# item} other {# items}}'
                { i: 10 }

           #5
            <Translate
                message="{count, plural, one {1 {item} selected} other {{count} {items} selected}}"
                values={{
                    count: amount
                }}
                words={{
                    items: 'Elements',
                    item: 'Element'
                }}
            />;
*/
